export const HOVER_ITEM_COLOR = '#394f85';
export const HEADER_BG_COLOR = 'transparent';
export const BLACK = '#17202A';
export const WHITE = '#FFFFFF';
export const DARK_BLUE = '#475C93';
export const MAIN_COLOR = '#817655';
export const COMPLEMENTARY_MAIN_COLOR = '#556081';
export const DARK_GREEN = '#768155';
export const MAROON = '#816055'

export const PRIMARY = '#4b63a3';
export const PRIMARY_LIGHT = '#7083ba';
export const PRIMARY_EXTRA_LIGHT = '#aab5d8';
export const PRIMARY_EXTRA_EXTRA_LIGHT = '#e0e5f3';
export const PRIMARY_DISABLED = '#a1accb'
export const SECONDARY = '#5c6fff';
export const ACCENT = '#ffa742';
export const ACCENT_HOVER = '#de8218';
export const SECONDARY_HOVER = '#2236c9';
export const SECONDARY_LIGHT = '#95a1fc';
export const SECONDARY_EXTRA_LIGHT = '#d2d6fa';


export const BLUE_1 = '#5c98a1';
export const BLUE_2 = '#99d4de';
export const BACKGROUND_COLOR = '#cce4fb';